import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const root = document.getElementById('alt-free-trial-root');

if (root) {
    createRoot(root).render(<App />);
}
